import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { BooleanCellData } from "@/utils/CellsFactory";
import trueIcon from "@/assets/icons/true-icon.svg";
import falseIcon from "@/assets/icons/false-icon.svg";
import BaseTooltip from "@/components-UI/BaseTooltip.vue";

interface Props {
    value?: boolean;
    data: BooleanCellData;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BooleanCell',
  props: {
    value: { type: Boolean },
    data: null
  },
  setup(__props: any) {

const props = __props as {
    value?: boolean;
    data: BooleanCellData;
}



const isShowIcon = computed(() => props.data.isIcon);
const getIcon = computed(() => props.value ? props.data.trueIcon ?? trueIcon : props.data.falseIcon ?? falseIcon);
const getValue = computed(() => props.value ? props.data.trueValue ?? 'Да' : props.data.falseValue ?? 'Нет');

const isShowTooltip = computed(() => props.data.isTooltip);
const getTooltip = computed(() => {
    if (!isShowTooltip.value) return '';
    const { trueTooltip, falseTooltip } = props.data;
    return props.value ? trueTooltip : falseTooltip;
});

const getClasses = computed(() => {
    const classes = {
        [`--${props.data.falseColor}`]: !props.value && props.data.falseColor,
        [`--${props.data.trueColor}`]: props.value && props.data.trueColor,
    };
    return Object.keys(classes).filter((key) => classes[key]).join(' ');
});

return { __sfc: true,props, isShowIcon, getIcon, getValue, isShowTooltip, getTooltip, getClasses, BaseTooltip }
}

})